import NotificationsDropdownWrapper from './NotificationsDropdownWrapper';
import NotificationsDropdownWrapperContainer from './NotificationsDropdownWrapper.container';

export default NotificationsDropdownWrapperContainer(
  NotificationsDropdownWrapper
);
